module.exports = __webpack_public_path__ + "static/media/duanwuBg4.3ba30f70.png";